import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import * as React from 'react';
import { Avatar, Button, Modal, Table } from 'antd';
import dayjs from 'dayjs';
import CustomersTable from '../../../../components/customers/CustomersTable';
import PageLoader from '../../../../microcomponents/PageLoader';
import PlanGate from '../../../../components/PlanGate';
import { planFeatures } from '@next-is-free-monorepo/next-is-free-shared-utils';
import { ColumnsType } from 'antd/es/table';
import { Customer } from '@next-is-free-monorepo/next-is-free-types';
import NAvatar from '../../../../../../libs/nif-web-components/src/microcomponents/NAvatar';
import { HugeiconsIcon } from '@hugeicons/react';
import { NotificationOff02Icon } from '@hugeicons/core-free-icons';
import { IconDots } from '@tabler/icons-react';
import { COLORS } from '@next-is-free-monorepo/globals';
import useShopAttrs from '../../../../utils/hooks/useShopAttrs';

export const Route = createFileRoute(
  '/_authenticated/customers/_customersLayout/'
)({
  component: RouteComponent,
  pendingComponent: () => <PageLoader />
});

const columns: ColumnsType<Customer> = [
  {
    title: 'Nome',
    dataIndex: 'display_name',
    key: 'display_name',
    sorter: (a, b) => a.username.localeCompare(b.username),
    render: (value: string, row) => (
      <Link to={`/customers/$customerId`} params={{ customerId: row.id }} className={'flex items-center gap-2'}>
        {/*  <Avatar size={'small'} className={'bg-primary!'}>
            {row.username?.slice(0, 1)}
          </Avatar>{' '}*/}
        <NAvatar text={row.username} />
        <p>{value || '-'}</p>
      </Link>
    )
  },
  {
    title: 'Username',
    dataIndex: 'username',
    key: 'username',
    sorter: (a, b) => a.username.localeCompare(b.username),
    render: (value: string, row) => <Link to={`/customers/$customerId`}
                                          params={{ customerId: row.id }}>@{value}</Link>
  },
  {
    title: 'Punti Attuali',
    dataIndex: 'points',
    key: 'points',
    sorter: (a, b) => a.points - b.points,
    render: (value: string) => <p>{value}</p>
  },
  /*  {
      title: 'Spesa totale',
      dataIndex: 'added_at',
      key: 'hour',
      render: (value: string) => <p>30€</p>
    },*/
  {
    title: 'Aggiunto il',
    dataIndex: 'added_at',
    key: 'hour',
    render: (value: string) => (
      <p style={{ textTransform: 'capitalize' }}>
        {dayjs(value).locale('it').format('DD/MM/YYYY HH:mm')}
      </p>
    )
  }
];

const mockCustomer: Customer= {
    id: '',
    display_name: 'Gatto Silvesto',
    username: 'gattosilvestro',
    points: 20,
    notifications_allowed: false,
    added_at: '',
    metadata: {}
  }

const mockData = Array(10).fill(null).map(() => ({ ...mockCustomer }));

function RouteComponent() {

  const shopAttrs = useShopAttrs()

  return (
    <div>
      {planFeatures(shopAttrs.data.subscription_plan, 'accessCustomers') ?
        <CustomersTable /> :
        <PlanGate featureKey={'accessCustomers'}>
          <Table columns={columns} dataSource={mockData} pagination={false} size={'small'} />
        </PlanGate>
      }
    </div>
  );
}
